import { render } from "./qnaComponent.vue?vue&type=template&id=10bce32e"
import script from "./qnaComponent.vue?vue&type=script&lang=js"
export * from "./qnaComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__